import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import CustomButton from "./Button";
const ConfirmationPopup = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose} sx={{ borderRadius: 2 }}>
      <DialogTitle
        sx={{ fontWeight: "bold", color: "primary.main", textAlign: "center" }}
      >
        Are you sure?
      </DialogTitle>
      <DialogContent sx={{ padding: 2, textAlign: "center" }}>
        <Typography variant="body1" color="textSecondary">
          This action cannot be undone. Are you sure you want to proceed?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <CustomButton text=" No" onClick={onClose} width="100px" />

        <CustomButton
          backgroundColor="#CCD3DA"
          color="#000"
          hoverColor="#A9A9A9"
          text="Yes"
          onClick={onConfirm}
          width="100px"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationPopup;
